export default __webpack_public_path__ + "static/media/footer-bg.ccc40cbf.png";